import React from 'react';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <>
      <SEO
        title="Privacy Policy | AssetWise Business Consultants"
        description="Privacy Policy for AssetWise Business Consultants - how we handle and protect your data."
        path="/privacy"
      />

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-cyan-600 hover:text-cyan-700 mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>

          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
            <p className="text-sm text-gray-600 mb-8">(Aligned with IT Act 2000 & SPDI Rules, India)</p>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Information We Collect</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We may collect:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Personal details (name, phone, email)</li>
                  <li>Financial information (income, loan requirement)</li>
                  <li>Identity documents (PAN, Aadhaar, bank statements)</li>
                  <li>Property-related details</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Purpose of Data Collection</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Your data is used to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Process loan applications</li>
                  <li>Connect with lenders and partners</li>
                  <li>Provide advisory and support services</li>
                  <li>Improve customer experience</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Data Sharing & Consent</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We may share your data with:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                  <li>Banks and NBFCs</li>
                  <li>Verification agencies</li>
                  <li>Legal/technical partners</li>
                </ul>
                <p className="text-gray-700 leading-relaxed font-semibold">
                  We do not sell personal data.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Data Security</h2>
                <p className="text-gray-700 leading-relaxed">
                  We implement reasonable safeguards to protect your data. However, no system is completely secure.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Marketing & WhatsApp Compliance</h2>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                  <li>We may send service and promotional messages via SMS, Email, and WhatsApp</li>
                  <li>Messages are sent based on user consent or legitimate business interest</li>
                  <li>You may opt out anytime by contacting us</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies Policy</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We may use cookies to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Enhance user experience</li>
                  <li>Analyze traffic and performance</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">User Rights</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You may:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Request access to your data</li>
                  <li>Request correction or deletion (subject to legal obligations)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Data Retention</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  We retain data:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>As long as required for service delivery</li>
                  <li>As mandated by applicable laws</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Policy Updates</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may update this policy periodically. Continued use implies acceptance.
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                Last Updated: April 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage;
